import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSelector } from "react-redux";
import axios from "axios";
import BlogCard from "./BlogCard";
import "./Blog.css";

const BlogListSection = () => {
  const [blogs, setBlogs]     = useState([]);
  const [loading, setLoading] = useState(true);

  const loggedInUser = useSelector((state) => state.auth.user);
  const token   = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.post(
          `${baseUrl}/all/blogs/home`,
          { page_number: 1, page_size: 3, order_by: "ASC" },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data.statusType === "SUCCESS") {
          setBlogs(response.data.blogs);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="blog-section">
      <div className="blog-section__container">

        <div className="blog-section__header">
          <div>
            <span className="blog-section__label">From our journal</span>
            <h2 className="blog-section__title">Latest <em>Blogs</em></h2>
          </div>
          <Link to="/view/all/blogs" className="blog-section__view-all">
            View all <ArrowRight size={14} strokeWidth={2.5} />
          </Link>
        </div>

        <div className="blog-section__grid">
          {loading ? (
            <div className="blog-empty">Loading blogs…</div>
          ) : blogs.length === 0 ? (
            <div className="blog-empty">No blogs found.</div>
          ) : (
            blogs.map((blog) => (
              <BlogCard
                key={blog._id}
                title={blog.title}
                description={blog.excerpt}
                imageUrl={blog.image_url}
                blogId={blog.id}
                author={blog.author}
                date={blog.publish_date}
                tags={blog.tags}
                slug={blog.slug}
              />
            ))
          )}
        </div>

      </div>
    </section>
  );
};

export default BlogListSection;